module.exports = "/_next/static/images/3537a1d6a3e98895c42a9a3855d969cc-woman-with-iphone@1x.jpg.webp";